<template>
  <div class="box">
    <h2 class="title is-4">Enregistrement Peppol</h2>

    <div v-if="loading" class="has-text-grey">Chargement...</div>

    <div v-else>
      <div v-if="organization && organization.recommand_company_id">
        <p class="has-text-success">
          ✅ Cette organisation est déjà enregistrée sur le réseau Peppol.
        </p>
        <p>
          <strong>ID Peppol :</strong> {{ organization.recommand_company_id }}
        </p>
        <p v-if="organization.recommand_team_id">
          <strong>Team ID :</strong> {{ organization.recommand_team_id }}
        </p>
      </div>

      <div v-else>
        <p class="has-text-danger">
          ⚠️ Cette organisation n’est pas encore enregistrée sur Peppol.
        </p>

        <button
          class="button is-primary mt-3"
          :class="{ 'is-loading': submitting }"
          :disabled="submitting"
          @click="registerCompany"
        >
          Enregistrer sur Peppol
        </button>
      </div>
    </div>

    <div v-if="message" class="notification mt-4" :class="messageClass">
      {{ message }}
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'PeppolCompany',
  data() {
    return {
      organization: {},
      loading: true,
      submitting: false,
      message: '',
      messageClass: '',
    };
  },
  async mounted() {
    await this.loadOrganization();
  },
  methods: {
    async loadOrganization() {
      try {
        const res = await api.get('organizations/me/active/');
        this.organization = res.data;
      } catch (err) {
        if (err.response?.status === 404) {
          // ✅ NORMAL: no active organization yet
          this.organization = null;
          return;
        }

        // ❌ Real error
        console.error('Erreur API:', err);
        this.message = 'Erreur serveur.';
        this.messageClass = 'is-danger';
      } finally {
        this.loading = false;
      }
    },

    async registerCompany() {
      this.submitting = true;
      this.message = '';

      try {
        const res = await api.post('peppol/register-company/');
        if (res.data.success) {
          this.message = '✅ Enregistrement réussi sur Peppol !';
          this.messageClass = 'is-success';
          this.organization.recommand_company_id = res.data.company_id;
        } else if (res.data.message) {
          this.message = res.data.message;
          this.messageClass = 'is-info';
        } else if (res.data.errors) {
          const details = Object.values(res.data.errors).flat().join(', ');
          this.message = `Erreur : ${details}`;
          this.messageClass = 'is-danger';
        } else {
          this.message = 'Erreur lors de l’enregistrement.';
          this.messageClass = 'is-danger';
        }
      } catch (err) {
        console.error('Erreur API:', err);
        this.message = 'Erreur de communication avec le serveur.';
        this.messageClass = 'is-danger';
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.box {
  max-width: 600px;
}
</style>
